const breadcrumb = {
  clients: 'Clients',
  details: 'Détails du client',
  new: 'Nouveau client',
  dictionary: 'dictionnaire client',
};

const button = {
  backToList: 'Retour à la liste',
  createClient: 'Créer un client',
  createDictionary: 'Créer un dictionnaire',
  deleteClient: 'Supprimer le client',
  dictionary: 'Modifier le dictionnaire client',
  details: 'Détails du client',
  add: 'Ajouter',
  update: 'Mettre à jour',
  back: 'Retour',
};

const form = {
  clientName: 'Nom du client',
  description: 'Description',
  email: 'Courriel',
  enterDescription: 'Entrez une description...',
  name: 'Nom',
  irthConfig: 'Configuration IRTH',
  apiKey: "Clé de l'API",
  apiUrl: "Adresse de l'API",
  clientTemplate: 'Modèle du client',
  licenseNumber: 'Numéro de licence',
  key: 'Clé',
  value: 'Valeur',
};

const message = {
  creationSuccess: 'Client créé avec succès',
  deletionConfirmation: 'Voulez-vous supprimer ce client?',
  updateSuccess: 'Client modifié avec succès',
  dictionaryCreationSuccess: 'Dictionnaire créé avec succès',
  dictionaryUpdateSuccess: 'Dictionnaire modifié avec succès',
  dictionaryDeletionConfirmation: 'Voulez-vous supprimer ce dictionnaire?',
};
export default {
  breadcrumb,
  button,
  form,
  message,
  name: 'Nom du client',
  user: 'Utilisateur',
  configuration: 'Configuration',
};
